import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DatePickerValue } from 'farmcloud-core';
import { WeekNumberInput } from '../../models/week-number-input.model';

@Component({
  selector: 'app-week-number',
  templateUrl: 'week-number.component.html',
  styleUrls: ['week-number.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WeekNumberComponent implements OnChanges {
  @Input() value: WeekNumberInput = null;

  week: number | null = null;
  isoYear: number | null = null;

  ngOnChanges(changes: SimpleChanges): void {
    if ('value' in changes) {
      const { week, year } = this.calculateIsoWeek(this.value);
      this.week = week;
      this.isoYear = year;
    }
  }

  private calculateIsoWeek(input: WeekNumberInput): { week: number | null; year: number | null } {
    const date = this.parseDate(input);
    if (!date) {
      return { week: null, year: null };
    }

    const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));

    const dayNum = d.getUTCDay() || 7;

    d.setUTCDate(d.getUTCDate() + 4 - dayNum);

    const isoYear = d.getUTCFullYear();
    const yearStart = new Date(Date.UTC(isoYear, 0, 1));

    const diffDays = Math.floor((d.getTime() - yearStart.getTime()) / 86400000);
    const week = Math.floor(diffDays / 7) + 1;

    return { week, year: isoYear };
  }

  private parseDate(input: WeekNumberInput): Date | null {
    if (!input) {
      return null;
    }

    if (input instanceof Date) {
      return isNaN(input.getTime()) ? null : input;
    }

    if (typeof input === 'string') {
      const parsed = new Date(input);
      return isNaN(parsed.getTime()) ? null : parsed;
    }

    const dp = input as DatePickerValue;
    const d = new Date(dp.year, dp.month - 1, dp.day);
    return isNaN(d.getTime()) ? null : d;
  }
}
